<template>
    <div class="projects">
      <ProjectsPage/>
    </div>
  </template>

<script>
import ProjectsPage from '@/components/ProjectsPage.vue'

export default {
  name: 'ProjectsView',
  components: {
    ProjectsPage
  }
}
</script>